// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.custom-swal-popup {
  height: auto;
}
.swal2-icon {
  margin: 1.5em auto 0.6em !important;
  width: 3em !important;
  height: 3em !important;
}
.swal2-html-container {
  margin: 1em 1.1em 0.3em !important;
  font-size: 1em !important;
}
.swal2-actions {
  margin: 0.5em auto 0 !important;
  gap: 20px !important;
  font-size: 15px !important;
}
.swal2-x-mark-line-left {
  top: 21px !important;
  left: 0px !important;
}
.swal2-x-mark-line-right {
  top: 21px !important;
  left: 0px !important;
}
.swal2-success-line-long {
  top: 26px !important;
  right: 0px !important;
  width: 36px !important;
}
.swal2-success-line-tip {
  top: 32px !important;
  left: 0px !important;
  width: 22px !important;
}
.swal2-title {
  font-size: 24px !important;
}

.carousel .slide iframe{
  margin: 20px 0px 15px 0px !important;
  height: 27rem !important;
}

.carousel .control-arrow, .carousel.carousel-slider .control-arrow{
  top: 42% !important;
  height: 50px !important;
  bottom: 1px !important;
  background: rgb(29, 29, 29) !important;
  opacity: 1 !important;
}

.swal2-icon-content{
  font-size: 2.75em !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.custom-swal-popup {\n  height: auto;\n}\n.swal2-icon {\n  margin: 1.5em auto 0.6em !important;\n  width: 3em !important;\n  height: 3em !important;\n}\n.swal2-html-container {\n  margin: 1em 1.1em 0.3em !important;\n  font-size: 1em !important;\n}\n.swal2-actions {\n  margin: 0.5em auto 0 !important;\n  gap: 20px !important;\n  font-size: 15px !important;\n}\n.swal2-x-mark-line-left {\n  top: 21px !important;\n  left: 0px !important;\n}\n.swal2-x-mark-line-right {\n  top: 21px !important;\n  left: 0px !important;\n}\n.swal2-success-line-long {\n  top: 26px !important;\n  right: 0px !important;\n  width: 36px !important;\n}\n.swal2-success-line-tip {\n  top: 32px !important;\n  left: 0px !important;\n  width: 22px !important;\n}\n.swal2-title {\n  font-size: 24px !important;\n}\n\n.carousel .slide iframe{\n  margin: 20px 0px 15px 0px !important;\n  height: 27rem !important;\n}\n\n.carousel .control-arrow, .carousel.carousel-slider .control-arrow{\n  top: 42% !important;\n  height: 50px !important;\n  bottom: 1px !important;\n  background: rgb(29, 29, 29) !important;\n  opacity: 1 !important;\n}\n\n.swal2-icon-content{\n  font-size: 2.75em !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
